<template>
<!-- 商品数据分析 -->
  <section>
    <!-- 搜索/查询 -->
    <el-col :span="24" class="order_toolbar toolbar pad_left">
      <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <p style="margin: 0;margin-left: -22px;" class="goodslist1">
            <span style="margin-left:31px;margin-top:5px">搜索/查询</span>
            <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
          </p>
          <div style="position: absolute;right:-19px;top:-10px" class="sanjiao"/>
        </div>
        <el-collapse-transition>
          <div style="padding:0px 12px" v-show="show3">
            <el-form :inline="true" :model="filters" style="margin-top:10px;display:flex;" class="findform">
              <!-- 顶部搜索框 -->
              <el-form-item style="display:flex;width:100%" label="关键词语：">
                <el-input :title="filters.keyword" v-model="filters.keyword" placeholder="商品编码 / 标题" maxlength="50"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"/>
              </el-form-item>
              <el-form-item style="display:flex;width:100%;" label="品 牌 商：" class="select letter">
                <el-cascader v-model="filters.pinpaishang"
                  style="width:100%"
                  placeholder="请选择"
                  :options="options3"
                  filterable
                  clearable
                  @change="handleChange"/>
              </el-form-item>
              <el-form-item style="display:flex;width:100%;" label="商品品类：" class="select">
                <el-select filterable
                  v-model="filters.brandTypeId"
                  placeholder="请选择"
                  style="background:#fff;width:100%"
                  ref="mySelect"
                  @change="getbrandarr">
                  <el-option
                    :label="item.Name"
                    :value="item.Id"
                    v-for="(item,index) in brandTypearr"
                    :key="index"/>
                </el-select>
              </el-form-item>
            </el-form>
            <el-form class="findform" style="display:flex;">
              <el-form-item style="display:flex;width:100%;" label="商品品牌：" class="select">
                <el-select filterable v-model="filters.brandId" placeholder="请选择">
                  <el-option
                    :label="item.Name"
                    :value="item.Id"
                    v-for="(item,index) in brandarr"
                    :key="index"/>
                </el-select>
              </el-form-item>
              <el-form-item style="display:flex;width:100%;margin-left:20px;" label="商品状态：" class="select">
                <el-select
                  v-model="filters.statusId"
                  placeholder="请选择"
                  style="background:#fff;width:100%;">
                  <el-option
                    :label="item.Name"
                    :value="item.Id"
                    v-for="(item,index) in statusptions"
                    :key="index"/>
                </el-select>
              </el-form-item>
              <el-form-item style="display:flex;width:100%;margin-left:20px;" label="销售类型：" class="select">
                <el-select
                  v-model="filters.goodsActiveId"
                  placeholder="请选择"
                  style="background:#fff;width:100%">
                  <el-option
                    :label="item.Name"
                    :value="item.Id"
                    v-for="(item,index) in goodsActiveOptions"
                    :key="index"/>
                </el-select>
              </el-form-item>
            </el-form>
            <el-form class="findform" style="float:right">
              <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
    </el-col>

    <!--列表-->
    <el-col :span="24" class="order_content main_container">
      <section class="model_section">
        <el-col :span="18" style>
          <p class="model_top_title">商品数据分析</p>
        </el-col>
      </section>
      <!-- table 列表 -->
      <div class="table_container">
        <div class="table_inner_container" style="height:auto">
          <el-table :data="dataList" class="invoice_tab" stripe border style="height:auto;max-height:500px">
            <el-table-column label="产品型号" align="center">
              <template scope="scope">
                <span :title="scope.row.GoodModelCode" :label="scope.row.GoodModelCode"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.GoodModelCode}}</span>
              </template>
            </el-table-column>
            <el-table-column label="名称" align="center">
              <template scope="scope">
                <span :title="scope.row.Title" :label="scope.row.Title"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.Title}}</span>
              </template>
            </el-table-column>
            <el-table-column label="所属品类" align="center">
              <template scope="scope">
                <span :title="scope.row.BrandTypeName" :label="scope.row.BrandTypeName"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.BrandTypeName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="所属品牌" align="center">
              <template scope="scope">
                <span :title="scope.row.BrandName" :label="scope.row.BrandName"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.BrandName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="甄惠装价" align="center">
              <template scope="scope">
                <span :title="scope.row.TzrPrice" :label="scope.row.TzrPrice"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.TzrPrice}}</span>
              </template>
            </el-table-column>
            <el-table-column label="浏览数" align="center">
              <template scope="scope">
                <span :title="scope.row.BrowseCount" :label="scope.row.BrowseCount" @click="endViews(scope)"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;color:#6786b4;margin-left:8px;cursor: pointer;"
                >{{scope.row.BrowseCount}}</span>
              </template>
            </el-table-column>
            <el-table-column label="收藏数" align="center">
              <template scope="scope">
                <span :title="scope.row.CollectionCount" :label="scope.row.CollectionCount" @click="endCollections(scope)"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;color:#6786b4;margin-left:8px;cursor: pointer;"
                >{{scope.row.CollectionCount}}</span>
              </template>
            </el-table-column>
            <el-table-column label="购物车数量" align="center">
              <template scope="scope">
                <span :title="scope.row.ShopCartCount" :label="scope.row.ShopCartCount"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.ShopCartCount}}</span>
              </template>
            </el-table-column>
            <el-table-column label="下单数" align="center">
              <template scope="scope">
                <span :title="scope.row.PlaceOrderCount" :label="scope.row.PlaceOrderCount"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.PlaceOrderCount}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--分页-->
        <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
          <el-pagination
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-size="10"
            :total="total"/>
        </el-col>
      </div>
    </el-col>
    
    <!-- 抽屉详情 size="50%" -->
    <el-drawer :visible.sync="dialogTable" :before-close="cancelForm" :show-close= false>
      <template v-slot:title>
        <ul class="drawer_title">
          <li>{{record}}</li>
          <el-button type="danger" @click="cancelForm">关 闭</el-button>
        </ul>
      </template>
      <div class="drawer_div">
        <el-table ref="table" :data="gridData" height="800">
          <el-table-column property="UserName" label="用户名称" align="center"/>
          <el-table-column property="CTime" :label="labelName" align="center"/>
          <template slot="append">
            <div class="scrollingTips">
              <p v-if="loading">正在加载</p>
              <p v-if="noMore">没有更多了</p>
            </div>
          </template>
        </el-table>
      </div>
    </el-drawer>
  </section>
</template>
<script>
import { SelectBrandTypeBaseDataByCondition } from '../../api/newOss';
import { getkind, getGoodsDataAnalysisList, SelectBBListByCondition, getGoodsBrowseRecordList,
  getGoodsCollectionRecordList, SelectGoodsBrandByBrandType } from "../../api/api";
export default {
  props: ["menuAction"],
  data() {
    return {
      dataId: "",
      show3:false,
      options3: [], // 品牌商
      cbId: 0,
      bcid: 0,
      brandTypearr: [], // 商品品类
      brandarr: [], // 商品品牌
      statusptions: "", // 商品状态
      goodsActiveOptions: [], // 销售类型
      dialogTable: false, // 抽屉详情
      timer: null,
      shenmark: "", // 审核意见
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      record: "浏览记录", // 浏览记录 & 收藏记录
      labelName: "",
      goodsPageIndex: 1, // 详情页页码
      goodsPageSize: 50, // 详情页条数 默认50条
      gridData: [],
      loading: false, // 是否加载中
      noMore: false, // 是否最后一页, 没有更多了
      filters: {
        keyword: "", // 关键词语
        pinpaishang: "",
        brandTypeId: 0, // 商品品类
        brandId: 0, // 品牌
        statusId: 0, // 商品状态
        goodsActiveId: 0 // 销售类型
      }
    }
  },
  methods: {
    //查询列表
    getDataAnalysis() {
      let addParams = {
        operId: localStorage.Id, // 当前操作人id
        keyword: this.filters.keyword, // 关键字
        cityId: this.cbId, // 商品所属城市id，查询全部时传0，基础数据加载同商品管理列表
        userBbId: this.bcid, // 商品所属品牌商id，查询全部传0，基础数据加载同商品管理列表
        brandTypeId: this.filters.brandTypeId, // 商品所属品类，如果查询全部传0，基础数据加载同商品管理列表
        brandId: this.filters.brandId, // 商品所属品牌，如果查询全部传0，基础数据加载同商品管理列表
        statusId: this.filters.statusId, // 商品状态，如果查询全部传0，，基础数据加载同商品管理列表
        goodsActiveId: this.filters.goodsActiveId, // 商品活动类型，查询全部时传0，基础数据加载同商品管理列表
        pageIndex: this.pageIndex,// 分页数据 当前页码
        pageSize: this.pageSize // 分页数据 每页显示条数
      };
      getGoodsDataAnalysisList(addParams).then(data => {
        this.dataList = data.ResultObj;
        this.total = data.RowsCount;
      })
      .catch(err => {
        this.dataList = [];
      });
    },
    // 点击浏览数
    endViews(scope) {
      this.record = "浏览记录";
      this.labelName = "浏览时间";
      this.dataId = scope.row.Id;
      this.goodsPageIndex = 1;
      this.dialogTable = true;
      this.browseNumber() // 加载数据, 默认先加载50条
      // 监听表格dom对象的滚动事件
      this.$nextTick(() => {
        let dom = this.$refs.table.$el.querySelector('.el-table__body-wrapper');
        dom.addEventListener('scroll', () => {
          let { scrollHeight, scrollTop, clientHeight } = dom
          const scrollDistance = scrollHeight - scrollTop - clientHeight
          if (scrollDistance <= 0 && this.loading !== true) {
            // 等于0证明已经到底，可以再次请求接口
            this.browseNumber() // 加载数据
          }
        })
      })
    },
    // 浏览数+无限滚动
    browseNumber() {
      var that = this;
      if (that.goodsPageIndex < that.goodsPageSize) {
        let addParams = {
          goodsId: that.dataId,
          pageIndex: that.goodsPageIndex, // 当前页码
          pageSize: that.goodsPageSize // 条数，默认50条
        };
        getGoodsBrowseRecordList(addParams).then(data => {
          if (data.ResultCode == 1) {
            that.gridData = that.gridData.concat(data.ResultObj)
            that.goodsPageIndex++
            that.loading = false
          } else {
            that.noMore = true
            that.loading = false
          }
        })
      } else {
        that.noMore = true
        that.loading = false
      }
    },
    // 点击收藏数
    endCollections(scope) {
      this.record = "收藏记录";
      this.labelName = "收藏时间";
      this.dataId = scope.row.Id;
      this.goodsPageIndex = 1;
      this.dialogTable = true;
      this.collectionNumber() // 加载数据, 默认先加载50条
      // 监听表格dom对象的滚动事件
      this.$nextTick(() => {
        let dom = this.$refs.table.$el.querySelector('.el-table__body-wrapper');
        dom.addEventListener('scroll', () => {
          let { scrollHeight, scrollTop, clientHeight } = dom
          const scrollDistance = scrollHeight - scrollTop - clientHeight
          if (scrollDistance <= 0 && this.loading !== true) {
            // 等于0证明已经到底，可以再次请求接口
            this.collectionNumber() // 加载数据
          }
        })
      })
    },
    // 收藏数+无限滚动
    collectionNumber() {
      var that = this;
      if (that.goodsPageIndex < that.goodsPageSize) {
        let addParams = {
          goodsId: that.dataId,
          pageIndex: that.goodsPageIndex, // 当前页码
          pageSize: that.goodsPageSize // 条数，默认50条
        };
        getGoodsCollectionRecordList(addParams).then(data => {
          if (data.ResultCode == 1) {
            that.gridData = that.gridData.concat(data.ResultObj)
            that.goodsPageIndex++
            that.loading = false
          } else {
            that.noMore = true
            that.loading = false
          }
        })
      } else {
        that.noMore = true
        that.loading = false
      }
    },
    // 关闭抽屉弹框
    cancelForm() {
      this.gridData = [];
      this.dialogTable = false;
      clearTimeout(this.timer);
    },
    // 重置
    fnReset() {
      this.filters = {
        keyword: "", // 关键词语
        pinpaishang: "",
        brandTypeId: 0, // 商品品类
        brandId: 0, // 品牌
        statusId: 0, // 商品状态
        goodsActiveId: 0 // 销售类型
      }
      this.cbId = '';
      this.bcid = '';
      // this.pageIndex = 1;
      // this.getDataAnalysis();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getDataAnalysis();
    },
    // 品牌商
    handleChange(val) {
      this.cbId = val[0];
      this.bcid = val[1];
    },
    //获取城市下的品牌商
    getBrandByCityId() {
      var obj = {
        userId: localStorage.Id
      };
      SelectBBListByCondition(obj).then(data => {
        let that = this;
        let cityList = [{value:0,label:"全部"}];
        data.ResultObj.map(item => {
          if(item.BbModel.length > 0) {
            let cityData = {value:item.CityId,label:item.CityName,children:[{value:0,label:"全部"}]}
            cityList.push(cityData)
            item.BbModel.map(brandBusiness => {
              cityData.children.push({value:brandBusiness.Id, label:brandBusiness.Name})
            })
          }
        });
        that.options3 = cityList
      });
    },
    // 获取品类
    getBrandType() {
      var obj = {
        userId: localStorage.Id
      };
      SelectBrandTypeBaseDataByCondition(obj).then(data => {
        if (data.ResultCode == 1) {
          this.getbrandarr()
          this.brandTypearr = data.ResultObj;
          this.brandTypearr.unshift({
            Id: 0,
            Name: "全部"
          });
        }
      });
    },
    // 获取品牌
    getbrandarr() {
      this.filters.brandId = 0
        var obj = {
          userId: localStorage.Id,
          brandTypeId: this.filters.brandTypeId
        };
        SelectGoodsBrandByBrandType(obj).then(data => {
          if (data.ResultCode == 1) {
            this.brandarr = data.ResultObj;
            this.brandarr.unshift({
              Id: 0,
              Name: "全部"
            });
          }
        });
    },
    // 获取商品状态
    getstatus() {
      let that = this;
      var loginParams = {
        tableName: "tBDGoodsStatus",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
          data = data.ResultObj;
          var obj = {
            Id: 0,
            Name: "全部"
          };
          data.unshift(obj);
          that.statusptions = data;
        })
    },
    // 获取销售类型
    getxiaoshoutype() {
      let that = this;
      var loginParams = {
        tableName: "tbdgoodsactive",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
          data = data.ResultObj;
          data.splice(3, 1)
          that.goodsActiveOptions = data;
          this.goodsActiveOptions.unshift({
            Id: 0,
            Name: "全部"
          });
        })
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getDataAnalysis();
    }
  },
  created() {
    let that = this;
    this.getBrandByCityId(); // 品牌商
    this.getBrandType(); // 获取品类
    this.getstatus(); // 商品状态
    this.getxiaoshoutype(); // 获取销售类型
    // 查询列表
    setTimeout(function() {
      that.getDataAnalysis();
    }, 200);
  }
}
</script>
<style scoped>
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}
.drawer_title>li:first-child{
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}
.drawer_div {
  width: 96%;
  margin: 0 auto;
}
.scrollingTips {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// goodsAnalysis.vue?690fd714